import React, { Component } from 'react';
import {useTonConnectUI, useTonWallet} from "@tonconnect/ui-react";

// Функциональный компонент для работы с хуками
const WalletButtonWrapper = ({ onWalletChange, onConnectUIChange }) => {
    const tonConnectUI = useTonConnectUI()[0];
    const wallet = useTonWallet();

    React.useEffect(() => {
        onWalletChange(wallet);
        onConnectUIChange(tonConnectUI);
    }, [wallet, tonConnectUI, onWalletChange, onConnectUIChange]);

    return null; // Не рендерим ничего
};

class TonWalletButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isConnected: false,
            tonConnectUI: null,
        };
    }

    handleWalletChange = (wallet) => {
        this.setState({ isConnected: wallet !== null });
    };

    handleConnectUIChange = (tonConnectUI) => {
        this.setState({ tonConnectUI });
    };

    async handleWalletClick() {
        let { isConnected, tonConnectUI } = this.state;

        if (!tonConnectUI) {
            console.error("TON Connect UI is not initialized");
            return;
        }
        //let isConnected = false;

        if (isConnected) {
            await tonConnectUI.disconnect();
        } else {
            tonConnectUI.openModal().catch((error) => {console.log(error)});
        }
    }

    render() {
        const { isConnected } = this.state;

        return (
            <>
                {/* Включаем обертку для работы с хуками */}
                <WalletButtonWrapper
                    onWalletChange={this.handleWalletChange}
                    onConnectUIChange={this.handleConnectUIChange}
                />
                <div
                    className={isConnected ? "upgrade__button upgrade__button--disconnect" : "upgrade__button"}
                    onClick={() => this.handleWalletClick()}
                >
                    {isConnected ? (
                        <span className="upgrade__button-text">
                            Disconnect TON wallet
                        </span>
                    ) : (
                        <span className="upgrade__button-text">Connect TON wallet</span>
                    )}
                </div>
            </>
        );
    }
}

export default TonWalletButton;